module.exports = __webpack_public_path__ + "img/sonphat.0f90045c.png";